import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=5681db64&scoped=true&"
import script from "./pay.js?vue&type=script&lang=js&"
export * from "./pay.js?vue&type=script&lang=js&"
import style0 from "./Pay.vue?vue&type=style&index=0&id=5681db64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5681db64",
  null
  
)

export default component.exports